<div class="icon-cell-renderer-wrapper"> 
  <nv-icon *ngIf="icon" [name]="icon" (click)="openModal();" [addHover]="true"></nv-icon>
  <div class="icon-space-filler" *ngIf="!icon" ></div>  
  {{displayValue}}
</div>